<template>
  <router-view />

  <LoadingOverlay :is-loading="isLoading" />

  <ConfirmDialogWrapper ref="confirmDialog" />

  <CookieDisclaimer />

  <Toast position="bottom-right" />
  <Toast position="bottom-left" group="bl" />
  <Toast position="bottom-center" group="bc" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'

import LoadingOverlay from './components/global/base/LoadingOverlay.vue'
import CookieDisclaimer from './components/global/shared/CookieDisclaimer.vue'

import { TokenService } from './services/TokenService'
import { useAppStore } from './stores/app'

import Toast, { ToastMessageOptions } from 'primevue/toast'
import { emitter } from './services/emitter'
import { useToast } from 'primevue/usetoast'
import ConfirmDialogWrapper from '@components/global/shared/ConfirmDialogWrapper.vue'
import { ConfirmDialogOptions } from '@models/ConfirmDialogOptions'

// import '@esri/calcite-components'

defineOptions({
  name: 'WeatherMap'
})

const toast = useToast()
const confirmDialog = ref<InstanceType<typeof ConfirmDialogWrapper>>()

const { isLoading } = storeToRefs(useAppStore())

onMounted(async () => {
  const isTokenValid = await TokenService.validateToken()
  // if (TokenService.getLoginToken() && this.hasUserData()) {
  if (isTokenValid) {
    await initApplication()
  } /* else {
      useAuthStore().logout()
    }*/

  emitter.on('showToast', showToast)
  emitter.on('showConfirmDialog', showConfirmDialog)
})

async function initApplication() {
  await useAppStore().init() // Fetch all data
}

function showToast(msg: ToastMessageOptions) {
  toast.add(msg)
}

function showConfirmDialog(options: ConfirmDialogOptions) {
  confirmDialog.value?.open(options)
}
</script>

<style scoped></style>
